/**
 * useBlockProps is a React hook that is used to mark the block wrapper element.
 * It provides all the necessary props like the class name.
 *
 * @see https://developer.wordpress.org/block-editor/packages/packages-block-editor/#useBlockProps
 *
 * RichText is a component that allows developers to render a contenteditable input,
 * providing users with the option to format block content to make it bold, italics,
 * linked, or use other formatting.
 *
 * @see https://developer.wordpress.org/block-editor/reference-guides/richtext/
 */

// eslint-disable no-shadow

/**
 * Lets webpack process CSS, SASS or SCSS files referenced in JavaScript files.
 * Those files can contain any CSS code that gets applied to the editor.
 *
 * @see https://www.npmjs.com/package/@wordpress/scripts#using-css
 */
import './editor.scss';
import { ContainerToImage } from '@components/image-container-switcher';
import icons from '../icons';
import React from 'react';

const {
  blockEditor: { useBlockProps, InnerBlocks, InspectorControls },
  components: { TabPanel, Panel, PanelBody, IconButton, ToggleControl },
  i18n: { __ },
} = wp;

/**
 * The edit function describes the structure of your block in the context of the
 * editor. This represents what the editor will render when the block is used.
 */

const Edit = (props) => {
  const { attributes, setAttributes, clientId } = props;
  const { activeTab, enableMobileImageTab } = attributes;
  const blockProps = useBlockProps();

  const innerBlockProps = {
    template: [['b3rg/desktop-image'], ['b3rg/mobile-image']],
    templateLock: 'all',
  };

  // To toggle the active tab
  const onTabSelect = (activeTab) => {
    setAttributes({ activeTab });
  };

  return (
    <>
      <InspectorControls>
        <Panel>
          <PanelBody>
            {activeTab === 'desktop' && (
              <ToggleControl
                label={__('Enable mobile image tab', 'b3rg')}
                checked={enableMobileImageTab}
                onChange={(enableMobileImageTab) => {
                  setAttributes({ enableMobileImageTab });
                  if (!enableMobileImageTab) {
                    setAttributes({ activeTab: 'desktop' });
                  }
                }}
              />
            )}
          </PanelBody>
        </Panel>
      </InspectorControls>
      <div {...blockProps} key={blockProps.id}>
        <ContainerToImage clientId={clientId} icon={icons.imageIcon} />
        <div className="mobile-content-tabs">
          <TabPanel
            activeClass="e-active-tab"
            orientation="horizontal"
            initialTabName={activeTab}
            onSelect={onTabSelect}
            tabs={[
              {
                name: 'desktop',
                title: (
                  <IconButton
                    label={__('Desktop Image', 'b3rg')}
                    icon="desktop"
                  />
                ),
                className: 'tab-desktop',
              },
              {
                name: 'mobile',
                title: (
                  <IconButton
                    label={__('Mobile Image', 'b3rg')}
                    icon="smartphone"
                  />
                ),
                className: `tab-mobile ${
                  !enableMobileImageTab && `tab-disabled`
                }`,
              },
            ]}
          >
            {(tab) => (
              <PanelBody>
                <div className={`${tab.className} e-active`}>
                  <InnerBlocks {...innerBlockProps} />
                </div>
              </PanelBody>
            )}
          </TabPanel>
        </div>
      </div>
    </>
  );
};

export default Edit;
